import { getMerchantToken } from "./merchantAuthApi";
const BASE = (process.env.REACT_APP_MERCHANT_API_BASE_URL || "http://secondbite-manage.localhost/merchant-api/v1").replace(/\/+$/, "");
const qs = (filters) => new URLSearchParams(filters).toString();
export const getListingPerformance = async (filters) => {
  const response = await fetch(`${BASE}/reports/listing-performance?${qs(filters)}`, { headers: { Accept: "application/json", Authorization: `Bearer ${getMerchantToken()}` } });
  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) throw new Error(payload?.message || "Unable to load listing performance.");
  return payload.data;
};
export const exportListingPerformance = async (filters) => {
  const response = await fetch(`${BASE}/reports/listing-performance/export?${qs(filters)}`, { headers: { Accept: "text/csv", Authorization: `Bearer ${getMerchantToken()}` } });
  if (!response.ok) throw new Error("Unable to export listing performance.");
  return response.blob();
};
